import {useEffect, useState} from "react";
import {findPayoutsWithPagination} from "../api/eventGroupApiClient";

export const usePayouts = (fromDate, toDate, page, pageSize, reloadTrigger) => {
    const [payouts, setPayouts] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const payoutsWithPagination = findPayoutsWithPagination(page, pageSize, fromDate, toDate, abortController.signal);

        payoutsWithPagination
            .then(
                (data) => {
                    const payouts = data.payouts;
                    const pagination = data.pagination;

                    setPayouts(payouts)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [fromDate, toDate, page, pageSize, reloadTrigger]);

    return {payouts : payouts, pagination};
};